import "dotenv/config";
import { z } from "zod";

/**
 * Validated environment. Fail fast at boot if anything required is missing —
 * we never want the server to come up half-configured (DB/auth/cache are all required).
 */
const EnvSchema = z.object({
  DATABASE_URL: z.string().min(1, "DATABASE_URL is required"),
  BETTER_AUTH_SECRET: z.string().min(16, "BETTER_AUTH_SECRET must be >= 16 chars"),
  BETTER_AUTH_URL: z.url(),
  MEMCACHED_SERVERS: z.string().min(1).default("127.0.0.1:11211"),
  MEMCACHED_USERNAME: z.string().optional(),
  MEMCACHED_PASSWORD: z.string().optional(),
  PORT: z.coerce.number().int().positive().default(4000),
  FRONTEND_ORIGIN: z.string().min(1).default("http://localhost:5173"),
});

const parsed = EnvSchema.safeParse(process.env);
if (!parsed.success) {
  console.error("❌ Invalid backend environment:\n", z.prettifyError(parsed.error));
  process.exit(1);
}

export const env = parsed.data;
